module.exports = __webpack_public_path__ + "img/diamonds.6f623bc.webp";